/**
 * Quote pools for the loading screen, organized by context so the copy
 * actually fits what's happening rather than showing the same generic
 * line everywhere. "general" is the fallback for any loading state
 * that doesn't specify a more specific context.
 */
export const QUOTE_POOLS = {
  general: [
    "Getting things ready for you",
    "Just a moment, we're on it",
    "Setting things in motion",
    "Hang tight, we're working on it",
    "Almost there...",
  ],
  compass: [
    "Finding your way",
    "Calibrating your journey",
    "Charting the best path for you",
    "Locking onto your direction",
    "Navigating to what's best for you",
  ],
  brand: [
    "Loading the Modus Experience",
    "Bringing Modus to life",
    "Modus is getting ready for you",
    "Preparing your Modus journey",
  ],
  npd: [
    "Fetching the latest CMS record",
    "Checking the National Provider Directory",
    "Pulling practices, endpoints and networks",
    "Cross-checking NPD and FHIR data",
  ],
  warm: [
    "We're finding the right care for you",
    "Matching you with the best fit",
    "Good things take a moment",
    "Making sure everything's just right",
  ],
};

export const QUOTE_CONTEXTS = Object.keys(QUOTE_POOLS);